import { defineComponent } from 'vue'

export const Button = defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    click: (_e: MouseEvent) => true,
  },
  setup (props, { slots, emit }) {
    return () => (
      <button
        class={`bg-[#245058] text-white font-bold px-2 py-4 items-center rounded-md ${
          props.disabled ? 'bg-gray-400' : ''
        }`}
        disabled={props.disabled}
        onClick={e => emit('click', e)}
      >
        <div class="grow">{slots.default?.()}</div>
      </button>
    )
  },
})
